import React, {useEffect} from "react";
import {ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "antd/dist/reset.css";
import ForgotPasswordModal from "./components/modal/ForgotPassword";
import {NewBooking} from "./components/NewBooking";
import Homepage from "./components/Homepage";
import {ConfigProvider} from "antd";
import fi from 'antd/locale/fi_FI';
import RivePreloader from "./components/RivePreloader";
import {useIsDev} from "./hooks/useIsDev";
import {syncWithServer} from "./components/actions/syncWithServer";
import {applyTranslations} from './translations'

applyTranslations();


function App() {
    useIsDev();
    useEffect(() => {
        syncWithServer();
    }, [])
    return (
        <ConfigProvider locale={fi}>
            <Homepage/>
            <ToastContainer position='bottom-right'/>
            <ForgotPasswordModal/>
            <RivePreloader/>
            <NewBooking/>
        </ConfigProvider>
    );
}

export default App;
